export const APP_TOKEN = 'appToken';